import Sidebar from '../../components/Sidebar';
import Game from '../../components/Game';
import Flip from '../../components/Flip';
import React, { useState } from 'react';
import background from "../../images/HOMEPAGE.png"

function Index() {
  const [amount, setAmount] = useState('0.01');
  return (
    <div className="flex flex-wrap pt-14 justify-center items-center  h-screen">
      <div  
       className="max-w-[1536px] max-h-[1920px] w-full flex flex-wrap justify-between items-center h-full">
        {/* <Game amount={amount} setAmount={setAmount} /> */}
        <Flip amount = {amount} setAmount={setAmount}/>
      </div>
    </div>
  );
}

export default Index;
